import React, { useEffect } from 'react';
import Transition from './Transition';
import '../styles/about-page.css';

const AboutPage = () => {
  // Verwijderd overflow lock, zodat pagina tot footer kan scrollen
  useEffect(() => {}, []);

  return (
    <div className="about-page min-h-screen">
      <iframe 
        src="/about-sections/complete-about.html" 
        style={{ 
          width: '100%', 
          border: 'none', 
          height: '100vh',
          display: 'block',
          position: 'relative',
          zIndex: 0
        }}
        title="About Page Content"
      />
    </div>
  );
};

export default Transition(AboutPage);
